/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put } from 'redux-saga/effects';
import { QUEUE_OPEN_SUCCESS } from '../features/queues';

function* queueOpened(action: any) {
  yield put({
    type: QUEUE_OPEN_SUCCESS,
    queueId: action.requestId,
    tickets: action.tickets
  });
}

export function* handleQueueOpenSaga() {
  yield takeLatest('web-socket/booth-queue-open/cbx', queueOpened);
}
